import { createModel } from "@rematch/core";
import { api } from "api";
import { ContractorListItemVm, ExcelColumn } from "api/generated/lumen";
import { RootModel } from "app/store";
import { mapToGetAllQuery } from "utils";
import { downloadFile } from "utils/file";
import {
  ListRequestParams,
  mergeListParamsWithPagination,
  OrderByType,
} from "widgets/table/useTableUtils";
import { getFilterParamsForContractorsGetRequests } from "../utils";

interface ContractorsListState {
  listParams: ListRequestParams;
  list: ContractorListItemVm[];
}

const initialState: ContractorsListState = {
  listParams: {
    pageSize: 10,
    order: [
      {
        orderBy: "name",
        orderByType: OrderByType.Ascending,
      },
    ],
  },
  list: [],
};

export const contractorsList = createModel<RootModel>()({
  state: initialState,
  reducers: {
    resetListParams(state) {
      state.listParams = {
        ...initialState.listParams,
        order: initialState.listParams.order,
      };
    },
    setList(
      state,
      {
        data,
        listParams,
      }: { data: ContractorListItemVm[]; listParams: ListRequestParams }
    ) {
      state.list = data;
      state.listParams = listParams;
    },
    reset: () => initialState,
  },
  effects: (dispatch) => {
    const { contractorsList } = dispatch;

    return {
      async fetchList(params: ListRequestParams = {}, state): Promise<void> {
        const { mergedParams, payload } =
          getFilterParamsForContractorsGetRequests(
            params,
            state.contractorsList.listParams
          );

        const data = await api.lumen.contractors.apiContractorsGetAllPost({
          getAllContractorsQuery: mapToGetAllQuery(payload),
        });

        const { items, ...pagination } = data;

        dispatch(
          contractorsList.setList({
            data: items || [],
            listParams: mergeListParamsWithPagination(mergedParams, pagination),
          })
        );
      },

      async generateExcel(columns: ExcelColumn[], state): Promise<void> {
        const { payload } = getFilterParamsForContractorsGetRequests(
          state.contractorsList.listParams,
          state.contractorsList.listParams
        );

        const data = await api.lumen.contractors.apiContractorsExportPostRaw({
          getAllContractorsExcelQuery: {
            ...mapToGetAllQuery(payload),
            columns,
            pageSize: -1,
          },
        });

        downloadFile(data.raw);
      },

      async deleteItem(id?: string): Promise<void> {
        if (typeof id === "string") {
          return api.lumen.contractors.apiContractorsIdDelete({ id });
        }
      },
    };
  },
});
